import React, { useState } from 'react';
import { DataTable } from '@/components/shared';
import { List } from '@refinedev/antd';
import { endPoints } from '@/api/configs';
import { useList } from '@/hooks/useList';
import { useNavigation, useTranslation } from '@refinedev/core';
import { ReloadOutlined, UserOutlined } from '@ant-design/icons';
import { getColumns } from './columns';
import { Button, Form, Select } from 'antd';
import { AssignRequestModal, ReviewUserModal } from '@/components/modals';
import { GetReq } from '@/api/types/getReq';
import { useProfileStore } from '@/core/useUserProfile';

export const RequestList = () => {
  const { translate } = useTranslation();
  const { push } = useNavigation();
  const { userData } = useProfileStore();
  const adminType = userData?.account?.admin?.admin_type;
  const [form] = Form.useForm();
  const [selectedUser, setSelectedUser] = useState<GetReq | undefined>(
    undefined
  );
  const [selectedRequest, setSelectedRequest] = useState<GetReq | undefined>(
    undefined
  );
  const [assignModalOpen, setAssignModalOpen] = useState(false);
  const {
    data,
    isLoading,
    page,
    setPage,
    isRefetching,
    setFilters,
    refetch,
    resolvedTotal,
  } = useList<{
    data: GetReq[];
  }>({
    endpoint: endPoints.request,
  });
  const [openModal, setOpenModal] = useState(false);
  const openShowUserModal = (show: boolean, user: GetReq | undefined) => {
    setOpenModal(show);
    setSelectedUser(user);
  };

  const openAssignModal = (request: GetReq) => {
    setSelectedRequest(request);
    setAssignModalOpen(true);
  };

  const columns = getColumns(
    translate,
    push,
    openShowUserModal,
    adminType,
    openAssignModal
  );

  const onSelectType = (value: string, key: string) => {
    setPage(1);
    setFilters((prev) => ({
      ...prev,
      [key]: value,
    }));
  };
  const resetFilters = () => {
    setPage(1);
    form.resetFields();
    setFilters({
      status: undefined,
      is_active: undefined,
      gender: undefined,
    });
  };
  return (
    <List
      title={
        <div className="flex gap-x-3">
          <UserOutlined />
          <h1>{translate('listing-request.title')}</h1>
        </div>
      }
      canCreate={false}
    >
      <Form form={form} layout="vertical">
        <div className="flex flex-wrap gap-x-3">
          <Form.Item name="type" className="w-full sm:w-1/6 min-w-[200px]">
            <Select
              onChange={(value) => onSelectType(value, 'type')}
              placeholder={translate('listing-request.type.placeholder')}
              options={[
                {
                  value: 'REGISTRATION',
                  label: translate('listing-request.type.REGISTRATION'),
                },
                {
                  value: 'POST_SUBMISSION',
                  label: translate('listing-request.type.POST_SUBMISSION'),
                },
              ]}
            />
          </Form.Item>
          <Form.Item name="status" className="w-full sm:w-1/6 min-w-[200px]">
            <Select
              onChange={(value) => onSelectType(value, 'status')}
              placeholder={translate('listing-request.status.placeholder')}
              options={[
                {
                  value: 'APPROVED',
                  label: translate('listing-request.status.APPROVED'),
                },
                {
                  value: 'REJECTED',
                  label: translate('listing-request.status.REJECTED'),
                },
                {
                  value: 'PENDING',
                  label: translate('listing-request.status.PENDING'),
                },
                {
                  value: 'ASSIGNED',
                  label: translate('listing-request.status.ASSIGNED'),
                },
              ]}
            />
          </Form.Item>
          <Form.Item name="stage" className="w-full sm:w-1/6  min-w-[200px]">
            <Select
              onChange={(value) => onSelectType(value, 'stage')}
              placeholder={translate('listing-request.stage.placeholder')}
              options={[
                {
                  value: 'ACADEMIC_SUPERVISION',
                  label: translate(
                    'listing-request.stage.ACADEMIC_SUPERVISION'
                  ),
                },
                {
                  value: 'PROGRAM_HEAD',
                  label: translate('listing-request.stage.PROGRAM_HEAD'),
                },
                {
                  value: 'REGISTRATION',
                  label: translate('listing-request.stage.REGISTRATION'),
                },
              ]}
            />
          </Form.Item>
          <Button
            className="mb-2 sm:mb-0"
            type="primary"
            icon={<ReloadOutlined />}
            onClick={resetFilters}
          />
        </div>
      </Form>
      <DataTable
        pageSize={10}
        currentPage={page}
        onPageChange={setPage}
        columns={columns}
        loading={isLoading || isRefetching}
        data={{
          data: data?.data.data || [],
          headers: {
            'x-total-count': resolvedTotal,
          },
        }}
      />
      <ReviewUserModal
        open={openModal}
        userData={selectedUser}
        onClose={() => setOpenModal(false)}
        refetch={refetch}
      />
      <AssignRequestModal
        open={assignModalOpen}
        request={selectedRequest}
        onClose={() => {
          setAssignModalOpen(false);
          setSelectedRequest(undefined);
        }}
        refetch={refetch}
      />
    </List>
  );
};
